import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';
import { formatDate, formatedDate } from '../../Helper/constent';
import StoreSelect from '../../Components/Store';

const ExpensesEntry = () => {
    const [listLoading, setListLoading] = useState(true);
    const [ExpenseAmount, setExpenseAmount] = useState('');
    const [ExpenseId, setExpenseId] = useState(null);
    const [msExpenseId, setMsExpenseId] = useState(null);
    const [ExpenseDate, setExpenseDate] = useState(null);
    const [FilterExpenseDate, setFilterExpenseDate] = useState(null);
    const [ExpenseNote, setExpenseNote] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [Expenses, setExpenses] = useState([]);
    const { apiUrl, apiHeadersJson, store_id, user_role } = useContext(ConfigContext);
    const headers = apiHeadersJson;
    const toast = useRef(null);


    const HandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const body = {
            expense_id: ExpenseId,
            ms_expense_id: msExpenseId,
            expense_date: ExpenseDate,
            expense_amount: ExpenseAmount,
            expense_note: ExpenseNote,
        };

        try {
            const response = await axios.post(`${apiUrl}/Management/CreateExpense`, body, { headers });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Management/GetExpenseList`, { params: { expense_date: FilterExpenseDate, store_id }, headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const fetchDropdownData = async () => {
        try {
            setListLoading(true);
            const [expensesRes] = await Promise.all([
                axios.get(`${apiUrl}/Masters/GetExpenseList`, { params: { store_id }, headers }),
            ]);
            setListLoading(false);
            setExpenses(expensesRes.data.data);

        } catch (error) {
            setListLoading(false);
            console.error('Error fetching DropdownData:', error);
        }
    };

    const handleResetForm = () => {
        setExpenseId(null);
        setExpenseAmount('');
        setExpenseNote('');
        setMsExpenseId('');
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Expense?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeleteBrand(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeleteBrand = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Management/DeleteExpense`, { params: { expense_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const GetInfo = async (id) => {
        try {
            const response = await axios.get(`${apiUrl}/Management/GetExpenseInfo`, { params: { expense_id: id }, headers })
            const { success, data, message } = response.data;
            if (success) {
                setExpenseId(data[0].expense_id);
                setExpenseAmount(data[0].expense_amount);
                setExpenseDate(data[0].expense_date);
                setMsExpenseId(data[0].ms_expense_id);
                setExpenseNote(data[0].expense_note);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000, });
            }
        } catch (error) {
            console.log('error', error);
        }
    }


    useEffect(() => {
        if (FilterExpenseDate) {
            GetList();
        }
        fetchDropdownData();
    }, [store_id]);

    useEffect(() => {
        if (!FilterExpenseDate) {
            var d = new Date(),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            let todays_date = [year, month, day].join('-');
            setFilterExpenseDate(todays_date);
            setExpenseDate(todays_date);
        }
        if (FilterExpenseDate) {
            GetList();
        }
    }, [FilterExpenseDate]);


    const ActionBody = (data) => {
        const createdDate = new Date(data.created_date);
        const currentDate = new Date();
        const timeDifference = currentDate - createdDate;
        const within24Hours = timeDifference <= 24 * 60 * 60 * 1000;
        const isAdmin = user_role === 'admin';
        const edit = (within24Hours || isAdmin);

        return (
            edit && <>
                <Button icon="pi pi-pencil" size='small' outlined onClick={() => GetInfo(data.expense_id)} />
                <Button outlined className='ms-3' size='small' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.expense_id)} />
            </>
        );
    };
    const ExpensesDate = (data) => {
        return (
            <>
                {formatedDate(data.expense_date)}
            </>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="main-heading">
                        <h6>Expense Entry</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Expense Entry</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-4">
                        <div className="card">
                            <h4 className="bg-dark text-white rounded-top p-3">Expense Entry</h4>
                            <form className='p-3' onSubmit={HandleSubmit}>
                                <div className="row">
                                    <div className="mb-2">
                                        <label className="form-label">Expense Name</label>
                                        <select
                                            className="form-select"
                                            value={msExpenseId || ""}
                                            disabled={listLoading}
                                            onChange={(selected) => setMsExpenseId(selected.target.value)}
                                        >

                                            <option value="" disabled>
                                                Select a expense
                                            </option>
                                            {Expenses.map((expense) => (
                                                <option key={expense.expense_id} value={expense.expense_id}>
                                                    {expense.expense_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="my-2">
                                        <label className="form-label">Expense Amount</label>
                                        <input
                                            type="number"
                                            value={ExpenseAmount}
                                            className="form-control"
                                            onChange={(e) => setExpenseAmount(e.target.value)}
                                            required={true}
                                            placeholder='Enter Expense Amount'
                                        />
                                    </div>
                                    <div className="my-2">
                                        <label className="form-label">Expense Date</label>
                                        <input
                                            type="date"
                                            value={ExpenseDate}
                                            className="form-control"
                                            onChange={(e) => setExpenseDate(e.target.value)}
                                            required={true}
                                            placeholder='Enter Expense Amount'
                                        />
                                    </div>
                                    <div className="my-2">
                                        <label className="form-label">Expense Note</label>
                                        <textarea
                                            type="text"
                                            value={ExpenseNote}
                                            className="form-control"
                                            onChange={(e) => setExpenseNote(e.target.value)}
                                            placeholder='Enter Expense Note'
                                        />
                                    </div>
                                </div>
                                {!ExpenseId && <Button
                                    type="submit"
                                    label={loading ? "Loading..." : "Submit"}
                                    className="btn btn-success mt-3"
                                    disabled={loading || !ExpenseAmount || !ExpenseDate || !msExpenseId}
                                />}
                                {ExpenseId &&
                                    <div>
                                        <Button
                                            type="submit"
                                            label={loading ? "Loading..." : "Update"}
                                            className="btn btn-success mt-3"
                                            disabled={loading || !ExpenseAmount}
                                        />
                                        <Button
                                            type="button"
                                            onClick={handleResetForm}
                                            label={loading ? "Loading..." : "Reset"}
                                            className="btn btn-light mt-3 float-end"
                                            disabled={loading}
                                        />
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8 mt-4">
                        <div className="card">
                            <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                                <h4 className="text-white"> Expenses On {formatedDate(FilterExpenseDate)}</h4>
                                <input
                                    type="date"
                                    value={FilterExpenseDate}
                                    className="form-control w-25"
                                    onChange={(e) => setFilterExpenseDate(e.target.value)}
                                    required={true}
                                    placeholder='Enter Expense Amount'
                                />
                            </div>
                            {dataTableLoading ? (
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                    <Skeleton shape='rectangle' width="100%" height="40px" className="mb-1" />
                                ))
                            ) : (
                                <DataTable size='small' value={rows} paginator rows={10} rowsPerPageOptions={[10, 20, 30]}>
                                    <Column field='expense_name' header='Expense Name' sortable />
                                    <Column body={ExpensesDate} header='Expense Date' sortable />
                                    <Column field='expense_amount' header='Expense Amount' sortable />
                                    <Column field='expense_note' header='Expense Note' />
                                    <Column body={ActionBody} header='Action' />
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExpensesEntry;
